// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-help-text{
    font-size: 12px;
    font-style: normal;
    color: rgb(117, 117, 117);
    padding: 5px 0px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/css-custom/css-custom.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":[".softlite-help-text{\r\n    font-size: 12px;\r\n    font-style: normal;\r\n    color: rgb(117, 117, 117);\r\n    padding: 5px 0px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
